import { useState } from "react";
import { useRouter } from "next/router";
import { staticLabelsSearch } from "../SearchResult/helper";

const SearchHeader = ({
  tabs = [],
  activeTab = "",
  setActiveTab = () => {},
  search = "",
  totalProductCount = 0,
  defaultLocale = "en",
}) => {
  const router = useRouter();
  const [openList, setOpenList] = useState(false);
  const handleActiveTabChange = tabLabel => {
    const type = tabs.find(tab => tab.label === tabLabel)?.type;
    router.push(
      {
        query: { ...router.query, type },
      },
      undefined,
      { shallow: true }
    );
    setActiveTab(tabLabel);
    setOpenList(false);
  };

  const noResults = tabs.filter(tab => tab.count > 0).length === 0;

  function toCapitalizedCase(text) {
    return text.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
  }

  return (
    <div className="max-w-screen-lg mx-auto bg-white text-[#232323] mx-2.5">
      <div className="bg-[#f5f5f5] pt-10 px-2.5 pb-5 md:pt-[120px] md:pb-[50px] md:px-0  text-center font-sans">
        {/* Title */}
        <h1 className="text-[32px] sm:text-[50px] md:text-5xl font-light text-gray-800 mb-2 font-['Helvetica-Light',_Helvetica,_sans-serif]">
          {staticLabelsSearch[defaultLocale]?.searchResultsFor} {`"${search}"`}
        </h1>

        {/* Total Count */}
        <p className="text-[10px] text-[#232323] mb-10 font-['HelveticaRoman',_Helvetica,_sans-serif]">
          {totalProductCount} {staticLabelsSearch[defaultLocale]?.searchResults}
        </p>

        {/* Button Group */}
        {noResults ? (
          <div className="pb-[60px]" />
        ) : (
          <div className="flex flex-col md:pb-[40px] mb-[20px] md:flex-row items-center justify-center gap-4 md:gap-12">
            <div className="px-[10px] w-full md:hidden">
              <div class="relative w-full">
                <button
                  type="button"
                  id="order-by"
                  name="order-by"
                  className="w-full px-4 py-3 border border-[#dbdbdb] text-left bg-white font-[helveticaRoman,_Helvetica,_sans-serif] text-[#232323] py-3 px-4 pr-8 rounded"
                  onClick={() => setOpenList(!openList)}
                >
                  {toCapitalizedCase(activeTab)}
                </button>
                {openList && (
                  <ul className="absolute z-10 w-full bg-white border border-[#dbdbdb] shadow-lg">
                    {tabs
                      .filter(tab => tab.count > 0)
                      .map((tab, index) => (
                        <li
                          key={tab?.label || index}
                          onClick={() => handleActiveTabChange(tab?.label)}
                          className={`block min-h-[42px] text-[#337ab7] font-[helveticaRoman,_Helvetica,_sans-serif] pt-[5px] pr-[5px] pb-[5px] pl-[15px] text-[14px] leading-[45px] no-underline flex justify-between items-center`}
                        >
                          <span className="normal-case">
                            {toCapitalizedCase(tab?.label)} ({tab.count}){" "}
                          </span>
                        </li>
                      ))}
                  </ul>
                )}
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    className="fill-current h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
            {tabs
              .filter(tab => tab.count > 0)
              .map((tab, index) => (
                <>
                  <button
                    key={index}
                    className={`hidden md:inline-block px-8 py-2 text-[14px] font-['helveticaMedium',_Helvetica,_sans-serif] font-bold tracking-[0.15em] transition-all duration-200 ${
                      activeTab === tab.label
                        ? "bg-black text-white rounded-sm"
                        : "bg-transparent text-[#232323] hover:text-black"
                    }`}
                    onClick={() => handleActiveTabChange(tab.label)}
                  >
                    {tab.label}
                    <span
                      className={`ml-1 font-normal ${
                        activeTab === tab.label
                          ? "text-gray-400"
                          : "text-gray-500"
                      }`}
                    >
                      ({tab.count})
                    </span>
                  </button>
                </>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchHeader;
